import { User } from './user-management';
import { createUserManager } from './cookie-user-management';
import { setIsLoggingOff } from '../../context/AppStateProvider';

export const usermanager = createUserManager();

let currentUser: User | undefined;

export function getUser() {
  return currentUser;
}

export async function logout(msg?: string) {
  setIsLoggingOff(true);

  await usermanager.removeUser();
  await usermanager.clearStaleState();
  await usermanager.signoutRedirect(msg);
}

usermanager.events.addUserLoaded((user) => {
  currentUser = user;
});

usermanager.events.addUserUnloaded(() => {
  currentUser = undefined;
});

// TODO: this is no longer required, because iat is now checked on the
// server, whose time should be accurate because of NTP or similar.
export function getErrorMessage(err: any): string {
  if (!err?.message) {
    return "Unknown error condition\n\nAn exception has been raised, but there is no associated message";
  }
  let message: string = err.message;
  let comment = "";

  for (let moreInfo of moreInfos) {
    if (moreInfo.regexp.test(message)) {
      comment = moreInfo.comment;
      break;
    }
  }

  return ("Error condition: " + message + "\n\n" + comment).trimEnd();
}

interface MoreInfo {
  regexp: RegExp;
  comment: string;
}

const moreInfos: MoreInfo[] = [
  {
    regexp: /iat is in the future/,
    comment: `This error condition can happen if the clock on your 
computer is inaccurate by more than five minutes. 

Verify that your computer's clock is accurate and then
try again.

If you are sure that the clock on your computer is 
accurate, please contact technical support.`
  }
];